import { zoneType } from '../../types';
import { createAPI, deleteByIdAPI, getAPI, getByIdAPI, getByNameAPI, updateAPI } from '../api-utils';

export const create = createAPI({
	actionType: zoneType.create,
	url: '/api/v1/Zone',
});

export const get = getAPI({
	actionType: zoneType.get,
	url: '/api/v1/Zone',
	type: 'core',
});

export const getById = getByIdAPI({
	actionType: zoneType.getById,
	url: '/api/v1/Zone',
});

export const getByName = getByNameAPI({
	actionType: zoneType.getByName,
	url: '/api/v1/Zone/name',
});

export const update = updateAPI({
	actionType: zoneType.update,
	url: '/api/v1/Zone/update',
});

export const deleteById = deleteByIdAPI({
	actionType: zoneType.deleteById,
	url: '/api/v1/Zone/delete',
});
